export const SET_FILTER = 'results/SET_FILTER';
export const SET_ANIMATING_IDS = 'contributions/SET_ANIMATING_IDS';
export const CLEAR_ANIMATING_IDS = 'contributions/CLEAR_ANIMATING_IDS';
export const SET_CATEGORY_FILTER = 'dashboard/SET_CATEGORY_FILTER';
